import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { MENUS } from 'src/app/demo/utils/menus.utils';

@Component({
  selector: 'app-route-indicator',
  templateUrl: './route-indicator.component.html',
  styleUrl: './route-indicator.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class RouteIndicatorComponent implements OnInit {
  indexToPage: MenuItem | null = null;
  namesToPage: MenuItem[] | null = null;

  constructor(
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const segments = this.activatedRoute.snapshot.pathFromRoot
      .map(route => route.url)
      .flat();
    if (segments.length > 0) {
      const nameModule = segments[2]?.path;
      const subnameModule = segments[3]?.path;
      const findIndex = MENUS.find(item => item.label === nameModule);
      if (findIndex) {
        this.indexToPage = { icon: findIndex.icon };
        this.namesToPage = [{ label: findIndex.text }];
        if (findIndex.items) {
          const findPage = findIndex.items.find(item => item.textRouter === subnameModule);
          if (findPage) this.namesToPage.push({ label: findPage.text });
        }
      }
    }
  }
}